export default __webpack_public_path__ + "static/media/check.059903fd.gif";